import Swiper from "swiper/bundle";

function initCtSliders() {
  document
    .querySelectorAll(".ct_slider.swiper:not(.admin_preview)")
    .forEach(function (sliderEl) {
      const autoplayEnabled = sliderEl.dataset.autoplay === "1";
      const duration = parseInt(sliderEl.dataset.duration, 10) || 5;

      const swiperOptions = {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: sliderEl.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: sliderEl.querySelector(".swiper-button-next"),
          prevEl: sliderEl.querySelector(".swiper-button-prev"),
        },
      };

      if (autoplayEnabled) {
        swiperOptions.autoplay = {
          delay: duration * 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      new Swiper(sliderEl, swiperOptions);
    });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCtSliders);
} else {
  initCtSliders();
}
